import { z } from "zod";
import { BaseFirestoreSchema } from "./firestore.schema";

// Schemas

export const ImportedFileSchema = BaseFirestoreSchema.extend({
  name: z.string(),
  type: z.string(),
  id: z.string(),
  extension: z.string().optional(),
  sizeKb: z.number().optional(),
  objectName: z.string(),
  path: z.string(),
});

// DTOs

export const CreateImportedFileDtoSchema = ImportedFileSchema.partial().and(
  ImportedFileSchema.required().pick({
    name: true,
    type: true,
    objectName: true,
    path: true,
  })
);

export const PutImportedFileDtoSchema = CreateImportedFileDtoSchema;

export const PatchImportedFileDtoSchema = ImportedFileSchema.partial();
